import * as React from 'react';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withHandlers, withState, withProps, mapProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { RemoteAutoCompleteField, RemoteAutoComplete, DateField, Date, InputField, Input } from '@components/form';
import { Divider } from 'material-ui';
import { getSummary } from '@modules/hr-workTimes/_workTimesActions';
import { duration } from 'moment';
import { required, validateTwoDates } from '@utils/validators';

const durationInMinutes = durationData => `${duration(durationData).asMinutes()} minut`;

const enhance = compose<any, any>(
  withState('overview', 'handleOverview', {}),
  withHandlers({
    onSubmit: ({ handleOverview }) => async formData => {
      const response = await getSummary(formData);
      handleOverview(response);
    }
  }),
  mapProps(({ overview, ...rest }) => ({
    overview: {
      worked: durationInMinutes(overview.worked),
      workedNight: durationInMinutes(overview.workedNight),
      workedWeekend: durationInMinutes(overview.workedWeekend),
      overtime25percent: durationInMinutes(overview.overtime25percent),
      overtime50percent: durationInMinutes(overview.overtime50percent),
      breaktime: durationInMinutes(overview.breaktime),
      businessTrip: durationInMinutes(overview.businessTrip),
      blackTimeOff: durationInMinutes(overview.blackTimeOff),
      otherVacationWedding: durationInMinutes(overview.otherVacationWedding),
      otherVacationFuneral: durationInMinutes(overview.otherVacationFuneral),
      otherVacationDoctor: durationInMinutes(overview.otherVacationDoctor),
      otherVacationUnpaid: durationInMinutes(overview.otherVacationUnpaid),
      workedNationalHoliday: durationInMinutes(overview.workedNationalHoliday),
      balance: durationInMinutes(overview.balance)
    },
    ...rest
  })),
  withProps(({ overview }) => ({
    initialValues: {
      worked: 'PT10H',
      ...overview
    }
  })),
  reduxForm({
    form: 'overview-form',
    validate: validateTwoDates,
    keepDirtyOnReinitialize: false,
    enableReinitialize: true
  }),

  breadcrumbs(() => [{ label: 'Časové položky - náhled' }])
);

const View: React.SFC<any> = ({ change, items, closeItem, ...props }) => (
  <div>
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={4}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                name="employee"
                label="Zaměstnanec *"
                url="/metropolis/api/hr/employees"
                labelFunction={o => get(o, 'fullName')}
                validate={[required]}
              />
            </Col>
            <Col md={4}>
              <DateField component={Date} name="from" label="Čas od *" dateOnly={false} validate={[required]} />
            </Col>
            <Col md={4}>
              <DateField
                component={Date}
                name="to"
                label="Čas do *"
                dateOnly={false}
                validate={[required]}
                allowFuture={true}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <h4>Náhled</h4>
          </Row>
          <Row>
            {[
              {
                label: 'Celkový odpracovaný čas',
                name: 'worked'
              },
              {
                label: 'Celkový noční odpracovaný čas',
                name: 'workedNight'
              },
              {
                label: 'Celkový odpracovaný čas o víkendech',
                name: 'workedWeekend'
              },
              {
                label: 'Celkový odpracovaný 25% nadčas',
                name: 'overtime25percent'
              },
              {
                label: 'Celkový odpracovaný 50% nadčas',
                name: 'overtime50percent'
              },
              {
                label: 'Celkový čas přestávek',
                name: 'breaktime'
              },
              {
                label: 'Celkový čas pracovních cest',
                name: 'businessTrip'
              },
              {
                label: 'Celkový čas černé volno',
                name: 'blackTimeOff'
              },
              {
                label: 'Celkový čas ostatní volna - svatba',
                name: 'otherVacationWedding'
              },
              {
                label: 'Celkový čas ostatní volna - pohřeb',
                name: 'otherVacationFuneral'
              },
              {
                label: 'Celkový čas ostatní volna - lékař',
                name: 'otherVacationDoctor'
              },
              {
                label: 'Celkový čas ostatní volna - neplacené volno',
                name: 'otherVacationUnpaid'
              },
              {
                label: 'Celkový čas - pracovní doba svátek',
                name: 'workedNationalHoliday'
              },
              {
                label: 'Saldo',
                name: 'balance'
              },
              {
                label: 'Celkový počet stravenek',
                name: 'mealVouchers'
              }
            ].map(({ name, label }, key) => (
              <Col md={4} key={key}>
                <InputField name={name} disabled={true} component={Input} label={label} />
              </Col>
            ))}
          </Row>
          <Divider />
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const SummaryForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-workTimes/summary/SummaryForm.tsx